/** Serialize known Tiptap blocks without losing literal text or nested marks. */
export const serializeTelegramHtml = (html: string): string => {
  const document = new DOMParser().parseFromString(html, 'text/html');

  const serializeBlock = (node: ChildNode): string => {
    if (!(node instanceof HTMLElement)) {
      return node.textContent ?? '';
    }
    if (node.tagName === 'P') {
      return node.innerHTML;
    }
    if (node.tagName === 'BLOCKQUOTE') {
      return `<blockquote>${Array.from(node.childNodes).map(serializeBlock).join('<br>')}</blockquote>`;
    }
    return node.outerHTML;
  };

  // Telegram accepts href, but not the browser attributes added by Link.
  document.querySelectorAll('a').forEach((link) => {
    ['target', 'rel', 'class'].forEach((attribute) => link.removeAttribute(attribute));
  });

  return Array.from(document.body.childNodes).map(serializeBlock).join('<br>');
};
